 export const customSelectStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: "48px", 
    height: "48px",
    borderRadius: "0.5rem", 
    borderColor: "#d1d5db", 
    boxShadow: "none",
    "&:hover": {
      borderColor: "#000",
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0 12px", 
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "48px",
  }),
};